import { IAppSettingsService } from '@mobile-data-access-services';

export function buildAppSettingFactory(
  appSettingsService: IAppSettingsService
) {
  return () => appSettingsService.loadSettingsAsync(true);
}
